module.exports = __webpack_public_path__ + "static/media/address-d.58aec3a8.svg";